import React from 'react';

import Dialog from '@/components/molecules/Dialog/Dialog';
import ShareDocumentDialog from '../../RDVShareDocument/components/ShareDocumentDialog';

const ShareDocumentInitial = ({
  goToUpload,
  goToChoose,
  dialogTitle,
  endSharing,
}) => {
  return (
    <Dialog
      open
      onClose={endSharing}
      title={dialogTitle}
      transitionDuration={{ exit: 0 }}
    >
      <ShareDocumentDialog
        showShareDocumentChooseDialog={goToChoose}
        showShareDocumentUploadDialog={goToUpload}
      />
    </Dialog>
  );
};

export default ShareDocumentInitial;
